module.exports = __webpack_public_path__ + "static/media/AlpErken.97e3ad49.JPG";